module.exports = __webpack_public_path__ + "static/media/purepecha_deusto.a5230a55.png";